import {
  AUTH_ROLES,
  EMAIL_FULL_DOMAIN_MAX_LIMIT,
  EMAIL_LOCAL_MAX_LIMIT,
  EMAIL_MAX_LENGTH,
  EMAIL_SUBDOMAIN_MAX_LIMIT,
  SPECIAL_CHARACTERS_ALLOWED,
  PASSWORD_MIN_LENGTH
} from 'utils/appConstants';

export const isEmailValid = email => {
  if (email) {
    //current database limit
    if (email.length > EMAIL_MAX_LENGTH) {
      return false;
    }
    if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      )
    ) {
      return false;
    }
    if (!email.includes('@')) {
      return false;
    }
    const splitEmail = email.split('@');
    const local = splitEmail[0];
    const domain = splitEmail[1];
    if (local.length > EMAIL_LOCAL_MAX_LIMIT) {
      return false;
    }
    if (domain.length > EMAIL_FULL_DOMAIN_MAX_LIMIT) {
      return false;
    }
    if (!domain.includes('.')) {
      return false;
    }
    const domainSplit = domain.split('.');
    //if there are subdomains, e.g. @fanclub.mailinglist.net,
    //each subdomain and domain can only be 63 characters
    for (let i = 0; i < domainSplit.length - 1; i++) {
      if (domainSplit[i].length > EMAIL_SUBDOMAIN_MAX_LIMIT) {
        return false;
      }
    }
    return true;
  }
};

export const isPasswordValid = password => {
  if (!password) {
    return false;
  }

  // Minimum of 8 characters
  // Includes at least 1 number
  // Includes at least 1 special character
  const passwordValidationRegex =
    '^(?=.*[A-Za-z])(?=.*\\d)(?=.*[@$!%*#?&])[A-Za-z\\d@$!%*#?&]{' +
    PASSWORD_MIN_LENGTH +
    ',}$';
  const newRegExp = new RegExp(passwordValidationRegex, 'g');
  if (!newRegExp.test(password)) {
    return false;
  }

  return true;
};

export const newPasswordsMatch = (newPassword, confirmNewPassword) =>
  newPassword === confirmNewPassword;

export const isAssignedRoleValid = assignedRole => {
  const authRoles = Object.keys(AUTH_ROLES).map(key => AUTH_ROLES[key]);
  if (authRoles.indexOf(assignedRole) >= 0) {
    return true;
  }

  return false;
};

export const isLengthValid = (string, length) => string.length <= length;

export const isNoSpecialCharactersValid = (
  string,
  pattern = SPECIAL_CHARACTERS_ALLOWED
) => {
  const regexMatch = string.match(pattern);
  if (regexMatch === null || regexMatch[0].length !== string.length) {
    return false;
  }
  return true;
};
